import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { DOC_SECTIONS } from '@/content/sections';
import { nexusColors } from '@/theme';

export function AppFooter(): JSX.Element {
  return (
    <Box component="footer" sx={{ borderTop: `1px solid ${nexusColors.line}`, mt: 10, py: 6 }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1.6fr 1fr 1fr 1fr' } }}>
          <Box>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5 }}>
              <Box component="img" src="/brand/nexus-mark.svg" alt="" sx={{ height: 22, width: 22 }} />
              <Typography sx={{ fontFamily: '"Space Grotesk", sans-serif', fontWeight: 700 }}>NexusRMM Wiki</Typography>
            </Stack>
            <Typography variant="body2" sx={{ color: nexusColors.muted, maxWidth: 320 }}>
              Guides, explainers, and a community-driven roadmap for every part of NexusRMM. Built by the same team that builds the product.
            </Typography>
          </Box>
          <Box>
            <Typography variant="overline" sx={{ color: nexusColors.faint }}>Product areas</Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              {DOC_SECTIONS.slice(0, 6).map((s) => (
                <Link key={s.id} component={RouterLink} to={`/${s.slug}`} underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>
                  {s.title}
                </Link>
              ))}
            </Stack>
          </Box>
          <Box>
            <Typography variant="overline" sx={{ color: nexusColors.faint, opacity: 0 }}>.</Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              {DOC_SECTIONS.slice(6).map((s) => (
                <Link key={s.id} component={RouterLink} to={`/${s.slug}`} underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>
                  {s.title}
                </Link>
              ))}
            </Stack>
          </Box>
          <Box>
            <Typography variant="overline" sx={{ color: nexusColors.faint }}>Community</Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              <Link component={RouterLink} to="/roadmap" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>Roadmap</Link>
              <Link component={RouterLink} to="/feature-requests" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>Feature requests</Link>
              <Link component={RouterLink} to="/community" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>Connect with the community</Link>
              <Link href="https://nexusrmm.ai" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>nexusrmm.ai</Link>
              <Link href="https://api-docs.nexusrmm.ai" underline="hover" sx={{ color: nexusColors.muted, fontSize: 13 }}>API reference</Link>
            </Stack>
          </Box>
        </Box>
        <Typography variant="caption" sx={{ color: nexusColors.faint, display: 'block', mt: 5 }}>
          © {new Date().getFullYear()} NexusRMM. This wiki documents real, shipped capability — pages under active development are labeled honestly rather than hidden.
        </Typography>
      </Container>
    </Box>
  );
}
